import React, { useState } from "react";
import { StyledText } from "../../../../components/common";
import { BackIcon, NoticeIcon } from "../../../../components/svgs";
import { useTheme } from "../../../../hooks";
import happyPulsers from "../../../../components/images/refer_card.png";
import styled from "styled-components";

export const EnterReferralCodeModal = ({ onBackDropClick }) => {
  const { themeContext, theme } = useTheme();
  const [referralCode, setReferralCode] = useState("");
  const handleSubmit = (e) => {
    e.preventDefault();
  };

  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];
  return (
    <div>
      <div
        style={{
          position: "absolute",
          top: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0,0,0,0.7)",
        }}
        onClick={onBackDropClick}
      />
      <div
        style={{
          position: "absolute",
          width: "100%",
          bottom: 0,
        }}
      >
        <ModalContentContainer>
          <div
            style={{
              width: 100,
              height: 5,
              backgroundColor: "#cbcbcb",
              borderRadius: 10,
              position: "absolute",
            }}
          />
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
              marginTop: 5,
              marginBottom: 5,
            }}
          >
            <div onClick={onBackDropClick}>
              <BackIcon />
            </div>
            <div>
              <NoticeIcon onClick={() => {}} fill="transparent" />
            </div>
          </div>

          <img
            width="90%"
            src={happyPulsers}
            alt="happy pulsers"
            style={{ borderRadius: 15 }}
          />
          <StyledText
            style={{
              textAlign: "center",
              paddingInline: 13,
            }}
          >
            Enter your Referral Code
          </StyledText>

          <FeedbackInputForm onSubmit={handleSubmit}>
            <input
              style={{
                width: "80%",
                padding: 15,
                borderRadius: 5,
                border: "1px solid black",
              }}
              placeholder="xxx-xxx"
              type="text"
              value={referralCode}
              onChange={(e) => setReferralCode(e.target.value)}
            />

            <button
              style={{
                backgroundColor: background,
                borderRadius: 30,
                border: "none",
                width: "60%",
                height: 40,
                marginTop: 20,
                fontFamily: "MTNBold",
                color: "white",
                fontSize: 14,
              }}
              type="submit"
            >
              Apply
            </button>
          </FeedbackInputForm>
        </ModalContentContainer>
      </div>
    </div>
  );
};

export default EnterReferralCodeModal;

const ModalContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: white;
  border-top-right-radius: 15px;
  border-top-left-radius: 15px;
  padding: 20px;
`;
const FeedbackInputForm = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
`;
